import { Component } from '@angular/core';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js';
import { Vector3 } from 'three';
import * as CANNON from 'cannon-es'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'animations';
  camera: any;
  scene: any;
  controls: any;
  ON: boolean = false;

  action1: any;
  action2: any;

  //Audio
  halloweenTheme: any;

  constructor() {

  }

  ngOnInit() {
    //Canvas
    const canvas = document.querySelector('.webgl') as HTMLCanvasElement;

    //Scene Initialisation  
    this.scene = new THREE.Scene();
    const cubeTextureLoader = new THREE.CubeTextureLoader()

    this.halloweenTheme = new Audio('assets/sounds/ambient/DemonCreepers.mp3');
    
    this.scene.background = new THREE.Color( 0x3f3f3d );

    const fog = new THREE.Fog('#2669b9', 1, 300)
    // this.scene.fog = fog;

    // Texture Loader
    const textureLoader = new THREE.TextureLoader()

    // const ambientLight = new THREE.AmbientLight( 0xffffff, 1 );
    // this.scene.add(ambientLight)
    // ambientLight.position.set(0, 5, 0);

    // Loaders and decoders

    const dracoLoader = new DRACOLoader()
    dracoLoader.setDecoderPath('assets/decoders/draco/')

    const gltfLoader = new GLTFLoader()
    gltfLoader.setDRACOLoader(dracoLoader)

    const mainTexture = textureLoader.load('assets/textures/modeltexture/bakedNew.jpg')
    mainTexture.flipY = false
    mainTexture.encoding = THREE.sRGBEncoding

    const floorTexture = textureLoader.load('assets/textures/modeltexture/bakedFloorObj1.jpg')
    floorTexture.flipY = false
    floorTexture.encoding = THREE.sRGBEncoding

    const pumpkinTexture = textureLoader.load('assets/textures/pumpkin/pumpkin3.jpeg')
    pumpkinTexture.flipY = false
    pumpkinTexture.encoding = THREE.sRGBEncoding

    const sceneMaterial = new THREE.MeshBasicMaterial({ map: mainTexture, side: THREE.DoubleSide, wireframe: false })

    const floorMaterial = new THREE.MeshBasicMaterial({ map: floorTexture, side: THREE.DoubleSide, wireframe: false })

    // THREE.ShaderLib[ 'lambert' ].fragmentShader = THREE.ShaderLib[ 'lambert' ].fragmentShader.replace(

    //   `vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;`,
  
    //   `#ifndef CUSTOM
    //       vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
    //   #else
    //       vec3 outgoingLight = diffuseColor.rgb * ( 1.0 - 0.3 * ( 1.0 - getShadowMask() ) ); // shadow intensity hardwired to 0.3 here
    //   #endif`
  
    // );

    // var material = new THREE.MeshLambertMaterial( { map: swingTexture, side: THREE.DoubleSide } );
    // material.defines = material.defines || {};
    // material.defines.CUSTOM = "";

    let mixer: any = null;
    gltfLoader.load(
      'assets/model/bzz/halloweenRawV2.glb',
      (gltf) => {

        // console.log(gltf.animations.length);

        gltf.scene.traverse(o=>{
          if(o instanceof THREE.Mesh) {
            // if(o.name === 'MainFloor') {
              // o.material = sceneMaterial;
              if(o.isMesh) {
                console.log('shadwing');
                
                o.castShadow = true;
                o.receiveShadow = true;
              }
              
            // } else {
            //   o.material = sceneMaterial;
            // }
          }
        });
        
        mixer = new THREE.AnimationMixer(gltf.scene);

        this.action1 = mixer.clipAction(gltf.animations[0]);
        this.action2 = mixer.clipAction(gltf.animations[1]);

        console.log(this.action1);
        

        const mainGroup = new THREE.Group();
        gltf.scene.scale.set(12,12,12)
        mainGroup.add(gltf.scene)
        this.scene.add(mainGroup)
        mainGroup.position.y += -.08
      }
    )

    // Physics
    // World
    const world = new CANNON.World()

    //Scene Optimisation 1 - we are using broadphase method 
    //to calculate the bodies and shapes position and rotation to optimise the scene
    world.broadphase = new CANNON.SAPBroadphase(world)

    //Scene Optimisation 2 - allowSleep method is used to avoid calculating the bodies which
    // are in rest, it will not be calculated in the scene, which gives
    // amazing scene optimisation for physical world.
    world.allowSleep = true

    world.gravity.set(0, - 9.82, 0)

    // Physics Materials
    const defaultMaterial = new CANNON.Material('default')

    const defaultContactMaterial = new CANNON.ContactMaterial(
        defaultMaterial,
        defaultMaterial,
        {
            friction: 0.8,
            restitution: 0.1
        }
    )

    world.addContactMaterial(defaultContactMaterial)
    world.defaultContactMaterial = defaultContactMaterial

    //Physic Sphere 

    //Physics Floor
    const floorShape = new CANNON.Plane()
    const floorBody = new CANNON.Body()
    floorBody.mass = 0
    floorBody.quaternion.setFromAxisAngle(
        new CANNON.Vec3(- 1, 0, 0),
        Math.PI * 0.5
    )
    floorBody.addShape(floorShape)
    world.addBody(floorBody)

    // Threejs Floor
    const floor = new THREE.Mesh(
        new THREE.PlaneBufferGeometry(10,10),
        new THREE.MeshStandardMaterial({
            color: '#777777',
            metalness: 0.3,
            roughness: 0.4,
            side: THREE.DoubleSide,
            // envMap: environmentMapTexture
        })
    )
    floor.receiveShadow = true
    floor.rotation.x = - Math.PI * 0.5
    this.scene.add(floor)

    // Threejs Lights
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.7)
    this.scene.add(ambientLight)

    const directionalLight = new THREE.DirectionalLight(0xffffff, 0.2)
    directionalLight.castShadow = true
    directionalLight.shadow.mapSize.set(1024, 1024)
    directionalLight.shadow.camera.far = 15
    directionalLight.shadow.camera.left = -7
    directionalLight.shadow.camera.top = 7
    directionalLight.shadow.camera.right = 7
    directionalLight.shadow.camera.bottom = -7
    directionalLight.position.set(5,5,5)
    this.scene.add(directionalLight)
    
    //Sphere
    const sphereGeometry = new THREE.SphereBufferGeometry(1, 20, 20)
    const sphereMaterial = new THREE.MeshStandardMaterial({
        metalness: 0.0,
        roughness: 0.8,
        map: pumpkinTexture
        // envMap: environmentMapTexture
    })
    //Objects
    const objectsToUpdate: any = [];

    window.addEventListener('click', ()=> {
      this.scene.add(createSphere(
        Math.random() * 0.5,
        {
            x: (Math.random() - 0.5) * 3,
            y: 3,
            z: (Math.random() - 0.5) * 3
        }
      ));
    });

    function createSphere(radius:any, position:any)
    {
        //Threejs Sphere Mesh
        const mesh = new THREE.Mesh(
            sphereGeometry,
            sphereMaterial
        )
        mesh.scale.set(radius,radius,radius)
        mesh.castShadow = true
        mesh.position.copy(position)
        // this.scene.add(mesh)

        // Cannon.js Sphere Mesh
        const shape = new CANNON.Sphere(radius)
        const body = new CANNON.Body({
            mass: 1,
            position: new CANNON.Vec3(0, 3, 0),
            shape: shape,
            material: defaultMaterial
        })
        body.position.copy(position)
        // body.addEventListener("collide", playHitSound)
        world.addBody(body)

        //Save in objects in array to update
        objectsToUpdate.push({
            mesh: mesh,
            body: body
        })
        return mesh
    }

    //Renderer Size
    const sizes = {
      width: innerWidth,
      height: innerHeight
    }

    //Render Initialisation
    const renderer = new THREE.WebGLRenderer({ antialias: true, canvas: canvas, alpha: false })
    // document.body.appendChild( renderer.domElement );
    renderer.shadowMap.enabled = true
    renderer.shadowMap.type = THREE.PCFSoftShadowMap
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    renderer.outputEncoding = THREE.sRGBEncoding

    //Camera Initialisation
    this.camera = new THREE.PerspectiveCamera(45, sizes.width / sizes.height, 0.1, 1000)
    // this.camera = new THREE.OrthographicCamera( window.innerWidth / - 220, window.innerWidth / 220, window.innerHeight /220, window.innerHeight / -220, -500, 1000);
    this.camera.position.set(0.5746557126112564,1.8428633422116711,7.645982549320840);
    this.camera.rotation.set(.01112591328167292,0.03718013851616317,-0.0004135847400220427);
    this.scene.add(this.camera)

    // Controls
    this.controls = new OrbitControls(this.camera, canvas)
    this.controls.target = new THREE.Vector3(0.25804037938784885,1.9375627947744027,-0.8652778430600251)
    this.controls.enableDamping = true;
    

    //Resize Event
    window.addEventListener('resize', () => {
      // Update sizes
      sizes.width = window.innerWidth
      sizes.height = window.innerHeight

      //Update camera
      this.camera.aspect = sizes.width / sizes.height
      this.camera.updateProjectionMatrix()

      //Update renderer
      renderer.setSize(sizes.width, sizes.height)
      renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    })

    // Clock
    let clock = new THREE.Clock()
    let oldELapsedTime = 0

    //Animate
    const tick = () => {

      //Clock
      const elapsedTime = clock.getElapsedTime()
      const deltaTime = elapsedTime - oldELapsedTime
      oldELapsedTime = elapsedTime

      //Update Physics World
      world.step(1 / 60, elapsedTime, 3)

      if(objectsToUpdate){
        for(const object of objectsToUpdate)
        {
            object.mesh.position.copy(object.body.position)
            object.mesh.quaternion.copy(object.body.quaternion)
        }
      }

      // Update mixer
      if(mixer !== null) {
        mixer.update(deltaTime)
      }

      this.controls.update()
      renderer.render(this.scene, this.camera)
      window.requestAnimationFrame(tick)
    }
    tick()
  }

  rotate() {
    
    if(this.controls.autoRotate) {
      this.controls.autoRotate = false;
      this.halloweenTheme.currentTime = 0;
      this.halloweenTheme.volume = 0.2;
      this.halloweenTheme.pause();
      this.action1.paused = true;
      this.action2.paused = true;
      this.ON = false;
    } else {
      // this.controls.autoRotate = true;
      this.halloweenTheme.currentTime = 0;
      this.halloweenTheme.volume = 0.2;
      this.halloweenTheme.play();

      this.action1.paused = false;
      this.action2.paused = false;
      
      this.action1.clampWhenFinished = true;
      this.action2.clampWhenFinished = true;

      this.action1.setLoop(THREE.LoopOnce, 1);
      this.action2.setLoop(THREE.LoopOnce, 1);

      this.action1.play();
      this.action2.play();
      
      this.ON = true;
    }
    
    // this.controls.rotateSpeed = 0.001
    
  }

}
